import { OrderAutomatizaionRow, Pair } from '@/Types';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userSelectors } from '@/Redux/User';
import { useLocalization } from '@/Hooks';
import { orderAutomatizationAsyncActions } from '@/ModalWindows/OrderAutomatizationModal/services/reducer';
import { AppDispatch } from '@/Redux/ConfigureStore';

export const useOrderPackagesOptions = (rowData: OrderAutomatizaionRow, ownContract: '' | 'yes' | 'no') => {
  const dispatch: AppDispatch = useDispatch();

  const {
    modalWindows: {
      orderLinkWithProduct: { Options },
    },
  } = useLocalization();

  useEffect(() => {
    if (ownContract) {
      dispatch(
        orderAutomatizationAsyncActions.getPackagesForOrderRequest({
          orderId: rowData.orderId,
          isOwnContract: ownContract === 'yes',
        }),
      );
    } // if
  }, [rowData, ownContract]);

  // Options
  const user = useSelector(userSelectors.currentUser);

  const contractTypeOptions = useMemo(() => {
    const result: Pair<string>[] = [{ key: 'yes', value: Options.OwnShippingContract }];

    const needShowShipCheaper = user?.canAccessPaidFeatures;

    if (needShowShipCheaper) {
      result.push({ key: 'no', value: Options.OrderShippingLableByShipCheaper });
    }

    return result;
  }, [Options]);

  return {
    contractTypeOptions,
  };
};
